'use client';

import { useEffect, useState } from 'react';

/**
 * Reads `cmsTicketId` from the URL search params on mount without calling
 * useSearchParams(), which would cause Next.js App Router to defer the
 * entire Suspense boundary to the client — resulting in a blank SSR output.
 *
 * cmsTicketId is stable for the lifetime of a SmartEdit preview session
 * (SmartEdit always does a full page reload when changing the ticket), so
 * reading it once on mount is sufficient for all callers.
 */
const useCmsTicketId = (): string | undefined => {
  const [cmsTicketId, setCmsTicketId] = useState<string | undefined>(undefined);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setCmsTicketId(params.get('cmsTicketId') ?? undefined);
  }, []); // run once on mount — cmsTicketId does not change mid-session

  return cmsTicketId;
};

export default useCmsTicketId;
